import { useMemo } from 'react';

import { roles } from '@/globalConsts';

export const useUserRole = (userFeaturesArr?: string[]) => {
	const userRole = useMemo(() => {
		if (!userFeaturesArr) return null;

		const featuresSet = new Set(userFeaturesArr);

		// 1) study_metrics: only if EXACTLY these two (no extras)
		const reportStrings = ['study_progress_metrics', 'patient_status_metrics'];
		const onlyReportStrings =
			featuresSet.size === reportStrings.length &&
			reportStrings.every((s) => featuresSet.has(s));
		if (onlyReportStrings) return roles.STUDY_METRICS;

		const studySiteStrings = ['study_site', 'flu_sniff_trial_site_management'];
		const onlyStudySiteStrings =
			featuresSet.size === studySiteStrings.length &&
			studySiteStrings.every((s) => featuresSet.has(s));
		if (onlyStudySiteStrings) return roles.STUDY_SITE_ADMIN;

		const flusniffPlusApproverStrings = [
			'flu_sniff_trial_site_management',
			'patients_approval',
		];
		const onlyFlusniffPlusApproverStrings =
			featuresSet.size === flusniffPlusApproverStrings.length &&
			flusniffPlusApproverStrings.every((s) => featuresSet.has(s));
		if (onlyFlusniffPlusApproverStrings) return roles.FLU_SNIFF_PLUS_APPROVER;

		// 2) care_agent: only if ALL careAgentStrings are present (extras allowed)
		const careAgentStrings = [
			'manual_screening',
			'survey_follow_up',
			'study_progress_metrics',
			'patient_status_metrics',
			'internal_study_admin',
			'patient_engagement_contact',
			'patient_contact',
		];
		const hasAllCareAgent = careAgentStrings.every((s) => featuresSet.has(s));
		if (hasAllCareAgent) return roles.CARE_AGENT;

		// 3) Other individual mappings
		if (featuresSet.has('patients_approval')) return roles.PATIENT_APPROVER;
		if (featuresSet.has('study_site')) return roles.TRIAL_SITES;
		if (featuresSet.has('flu_sniff_trial_site_management')) return roles.FLU_SNIFF;

		// 4) No match
		return null;
	}, [userFeaturesArr]);

	return userRole;
};
